module.exports = __webpack_public_path__ + "../resources/img/ic_arrow_up.cb4bbb06.svg";